import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthServiceCustom } from 'src/shared/service/auth.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserAuthorizedCanActivate } from './user-authorized.guard.';


@Injectable()
export class UserUnAuthorizedCanActivate  {// CanActivateChild

  constructor(private authService: AuthServiceCustom) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
    const url: string = state.url;

    if (!this.authService.configReady) {
      return this.authService.clientConfigLoaded.pipe(map(x => {
        return this.checkAndRedirect(url, route);
      }));
    }

    return this.checkAndRedirect(url, route);
  }

  private checkAndRedirect(url: string, route: ActivatedRouteSnapshot): boolean {
    if (!UserAuthorizedCanActivate.isAuthorized(this.authService, route)) {
      return true;
    }
    this.authService.setRedirectUrl(url);
    this.authService.navigateToUrl('home');
    return false;
  }
}
